export const LogoMark = ({ className = "h-10 w-10" }) => (
  <span
    className={`inline-flex shrink-0 items-center justify-center rounded-2xl bg-ink shadow-soft ${className}`}
  >
    <svg viewBox="0 0 64 64" className="h-[64%] w-[64%]" aria-hidden="true">
      <path
        d="M32 13c-8.6 0-14.6 5.4-14.6 12.8 0 4.2 1.6 7.5 3.1 11.2C22.3 41.8 22.7 55 27.2 55c3.9 0 3-12.4 4.8-15.7h.1C33.8 42.6 33 55 36.9 55c4.5 0 4.9-13.2 6.7-18 1.5-3.7 3.1-7 3.1-11.2C46.6 18.4 40.6 13 32 13z"
        fill="#5EEAD4"
      />
    </svg>
  </span>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark className="h-9 w-9" />
    <span className="font-display text-xl font-semibold tracking-tight">AssisDent</span>
  </span>
);
